import type { PatientEnCours, PatientPecState, PatientQuoteState } from "cadendar-shared";

export const stateMap = {
  toClassify: "A classer",
  done: "Fini",
  apt_booked: "Rdv pris",
  must_call_back: "Doit rappeler",
  must_be_called_back: "A rappeler",
  todo: "Tâches à faire",
} satisfies Record<PatientEnCours["state"], string>;

export const quoteMap = {
  quote_sent: "Remis",
  todo: "A faire",
  quote_accepted: "Accepté",
  quote_refused: "Refusé",
  quote_abandoned: "Abandonné",
  quote_created: "Créé",
} satisfies Record<PatientQuoteState, string>;

export const pecMap = {
  todo: "A faire",
  waiting_for_answer: "En attente de réponse de la mutuelle",
  received: "Reçue",
  error: "Erreur",
  waiting_for_assurance_card: "En attente de carte de mutuelle",
} satisfies Record<PatientPecState, string>;
